export class Segment
{
    SegmentID: number;
    SegmentName: string;
    SegmentDescription: string;
    IsActive : boolean = true;
    ModifiedBy : number;
}